import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';

import { AiAction } from './ai.actions';
import { Action } from '../shared/common.action';
import { GoAPI } from '../connector/shared/api.go.service';

@Injectable()
export class AiEffects {

  @Effect() analyseDocument$ = this.actions$
    .pipe(ofType(AiAction.ANALYSE))
    .filter((action: Action) => !!action.payload)
    .mergeMap((action: Action) => this.api.analyseDocument().form(action.payload.data)
      .mergeMap(response => Observable.from([
        this.aiAction.analyseSuccess()
      ]))
      .catch((error: any) => Observable.of(this.aiAction.analyseFailed()))
    );

  @Effect() similarity$ = this.actions$
    .pipe(ofType(AiAction.SIMILARITY))
    .filter((action: Action) => !!action.payload)
    .mergeMap((action: Action) => this.api.similarity().post(action.payload.data)
      .mergeMap(response => Observable.from([
        this.aiAction.similaritySuccess(action.payload.data.id, response)
      ]))
      .catch((error: any) => Observable.of(this.aiAction.similarityFailed(action.payload.data.id, error)))
    );

  constructor(private api: GoAPI,
              private actions$: Actions,
              private aiAction: AiAction) {
  }
}
